var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 19 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "evenodd",
    transform: "translate(-1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,19.0307201 C1,20.1179267 1.88166639,21 2.96837147,21 L17.4030956,21 C18.4898006,21 19.371467,20.1179267 19.371467,19.0307201 L19.371467,7.87146703 L1,7.87146703 L1,19.0307201 Z M3.62853297,11.1571332 C3.62853297,10.79571 3.92344801,10.5 4.28389973,10.5 L8.21610027,10.5 C8.57655199,10.5 8.87146703,10.79571 8.87146703,11.1571332 L8.87146703,15.0999327 C8.87146703,15.461356 8.57655199,15.7570659 8.21610027,15.7570659 L4.28389973,15.7570659 C3.92344801,15.7570659 3.62853297,15.461356 3.62853297,15.0999327 L3.62853297,11.1571332 Z M17.4030956,2.62288022 L15.4347241,2.62288022 L15.4347241,0.655720054 C15.4347241,0.295074024 15.1394684,0 14.7786003,0 L13.4663526,0 C13.1054845,0 12.8102288,0.295074024 12.8102288,0.655720054 L12.8102288,2.62288022 L7.56123822,2.62288022 L7.56123822,0.655720054 C7.56123822,0.295074024 7.2659825,0 6.9051144,0 L5.59286676,0 C5.23199865,0 4.93674293,0.295074024 4.93674293,0.655720054 L4.93674293,2.62288022 L2.96837147,2.62288022 C1.88166639,2.62288022 1,3.50400404 1,4.59004038 L1,6.55720054 L19.371467,6.55720054 L19.371467,4.59004038 C19.371467,3.50400404 18.4898006,2.62288022 17.4030956,2.62288022 Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.4dd5910734a99613769b6a989c498256.svg";
export { ForwardRef as ReactComponent };